var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00016 4C1.82335 4 1.65378 4.07024 1.52876 4.19526C1.40373 4.32029 1.3335 4.48986 1.3335 4.66667C1.3335 4.84348 1.40373 5.01305 1.52876 5.13807C1.65378 5.2631 1.82335 5.33333 2.00016 5.33333H18.0002C18.177 5.33333 18.3465 5.2631 18.4716 5.13807C18.5966 5.01305 18.6668 4.84348 18.6668 4.66667C18.6668 4.48986 18.5966 4.32029 18.4716 4.19526C18.3465 4.07024 18.177 4 18.0002 4H2.00016ZM1.3335 10C1.3335 9.82319 1.40373 9.65362 1.52876 9.5286C1.65378 9.40357 1.82335 9.33333 2.00016 9.33333H18.0002C18.177 9.33333 18.3465 9.40357 18.4716 9.5286C18.5966 9.65362 18.6668 9.82319 18.6668 10C18.6668 10.1768 18.5966 10.3464 18.4716 10.4714C18.3465 10.5964 18.177 10.6667 18.0002 10.6667H2.00016C1.82335 10.6667 1.65378 10.5964 1.52876 10.4714C1.40373 10.3464 1.3335 10.1768 1.3335 10ZM1.3335 15.3333C1.3335 15.1565 1.40373 14.987 1.52876 14.8619C1.65378 14.7369 1.82335 14.6667 2.00016 14.6667H18.0002C18.177 14.6667 18.3465 14.7369 18.4716 14.8619C18.5966 14.987 18.6668 15.1565 18.6668 15.3333C18.6668 15.5101 18.5966 15.6797 18.4716 15.8047C18.3465 15.9298 18.177 16 18.0002 16H2.00016C1.82335 16 1.65378 15.9298 1.52876 15.8047C1.40373 15.6797 1.3335 15.5101 1.3335 15.3333Z",
    fill: "#58B6A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ee595e60.svg";
export { ForwardRef as ReactComponent };